import { render, staticRenderFns } from "./embeddedNote.vue?vue&type=template&id=a3ebb376&scoped=true&"
import script from "./embeddedNote.vue?vue&type=script&lang=js&"
export * from "./embeddedNote.vue?vue&type=script&lang=js&"
import style0 from "./embeddedNote.vue?vue&type=style&index=0&id=a3ebb376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ebb376",
  null
  
)

export default component.exports